import { Box, Text, Title } from '@mantine/core';
import styled from '@emotion/styled';

import { mediaQueryMobile, mediaQueryTablet } from '~/styles/mixins';

import InstagramLogoComponent from '~/assets/social/instagram-circular-filled.svg';
import LinkedInLogoComponent from '~/assets/social/linkedin-circular-filled.svg';
import TwitterLogoComponent from '~/assets/social/twitter-circular-filled.svg';
import YoutubeLogoComponent from '~/assets/social/youtube-circular-filled.svg';
import UpraisedLogoComponent from '~/assets/upraised-logo.svg';

const Flex = styled(Box)`
  display: flex;
  height: ${(p) => p.height};
  width: ${(p) => p.width};
  flex-direction: ${(p) => p.flexDirection};
  justify-content: ${(p) => p.justifyContent};
  align-items: ${(p) => p.alignItems};
`;

export const Root = styled(Box)`
  background-color: #fafafa;
`;

export const Container = styled(Box)`
  max-width: 1272px; // 1272 = 1224 content + 24 padding on left and right
  margin: 0 auto;
  padding: 0 24px;
  ${mediaQueryMobile} {
    padding: 0 20px;
  }
`;

export const ContentWrapper = styled(Box)`
  padding: 80px 0px;
  ${mediaQueryTablet} {
    padding: 48px 40px;
  }
  ${mediaQueryMobile} {
    padding: 40px 0 24px 0;
  }
`;

export const LogoContainer = styled(Box)`
  display: inline-block;
  cursor: pointer;
  margin-right: 40px;
`;
LogoContainer.defaultProps = { component: 'a' };

export const UpraisedLogo = styled(UpraisedLogoComponent)`
  display: block;
  height: 32px;
`;

export const LinksBlockWrapper = styled(Flex)`
  margin-left: auto;
  gap: 16px;
  ${mediaQueryTablet} {
    margin-left: 0;
    flex-direction: column;
  }
  ${mediaQueryMobile} {
    margin-left: 0;
    margin-top: 24px;
  }
`;

export const LinksBlock = styled(Flex)`
  flex-direction: column;
  & + & {
    margin-left: 80px;
  }
  ${mediaQueryTablet} {
    & + & {
      margin-left: 0;
    }
  }
`;

export const LinkBlockHeading = styled(Title)`
  color: #787878;
  text-transform: uppercase;
  letter-spacing: unset;
  ${mediaQueryMobile} {
    font-size: 14px;
  }
`;
LinkBlockHeading.defaultProps = { order: 6 };

export const LinkBlockLinks = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledTextLink = styled.a`
  color: #555555;
  margin-top: 16px;
  text-decoration: none;
  &:hover {
    color: #787878;
  }
`;
StyledTextLink.defaultProps = { target: '_blank' };

export const TagContainer = styled(Box)`
  display: inline;
  padding: 2px;
  background: #edf6ff;
  cursor: pointer;
  border-radius: 2px;
  &:hover {
    background: #cfe7ff;
  }
`;

export const TagText = styled(Text)`
  font-family: ${(p) => p.theme.fontFamily};
  font-style: normal;
  font-size: 10px;
  font-weight: 600;
  line-height: 100%;
  text-transform: uppercase;
  margin: 0;
  color: #0c7beb;
`;

export const CopyrightAndSocialLinksContainer = styled(Flex)`
  border-top: 1px solid #e9e9e9;
  align-items: center;
  justify-content: space-between;
  padding: 24px 0px 0px;
  margin-top: 80px;
  ${mediaQueryTablet} {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 64px;
  }
  ${mediaQueryMobile} {
    margin-top: 24px;
  }
`;

export const SocialIconsWrapper = styled(Flex)`
  ${mediaQueryTablet} {
    margin-top: 24px;
  }
`;

export const CopyrightText = styled.a`
  text-decoration: none;
  color: #969696;
  &:hover {
    color: #c4c4c4;
  }
  & + & {
    margin-left: 32px;
  }
  ${mediaQueryMobile} {
    & + & {
      margin-left: 0;
      margin-top: 16px;
    }
  }
`;

export const SocialIcon = styled(Box)`
  height: 28px;
  width: 28px;
  flex-shrink: 0;
  color: #969696;
  cursor: pointer;
  &:hover {
    color: #c4c4c4;
  }
`;

export const LinkedInLogo = styled(SocialIcon)``;
LinkedInLogo.defaultProps = { component: LinkedInLogoComponent };
export const TwitterLogo = styled(SocialIcon)``;
TwitterLogo.defaultProps = { component: TwitterLogoComponent };
export const YoutubeLogo = styled(SocialIcon)``;
YoutubeLogo.defaultProps = { component: YoutubeLogoComponent };
export const InstagramLogo = styled(SocialIcon)``;
InstagramLogo.defaultProps = { component: InstagramLogoComponent };
